import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {KeycloakService} from "./keycloak.service";
import {ApiEndpoints} from "./api-endpoints";

@Injectable()
export class HttpService {
  public userListUrl = ApiEndpoints.GET_ALL_USERS;
  public username: string = KeycloakService.username;
  public ownerId;
  public hasAcces;
  public errorStatus;
  public errorText;
  constructor(private http: HttpClient) {}

  getUserList(){
    var body: any = {
      "name": ""
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    return this.http.post<any>(this.userListUrl,body, options)
  }

  getNetworkInfo(id) {
    var body: any = { "virtId": id, "username": this.username };
    var url = ApiEndpoints.GET_NETWORK_SERVER;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    return this.http.post<any>(url, body, options);
  }

  getNetworkServerGroupInfo(id) {
    var body: any = { "virtId": id, "username": this.username };
    var url = ApiEndpoints.GET_NETWORK_SERVER_GROUP;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    return this.http.post<any>(url, body, options);
  }

  getJoinInfo(id) {
    var body: any = {"virtId": id, "username": this.username};
    var url = ApiEndpoints.GET_JOIN_SERVER;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    return this.http.post<any>(url, body, options);
  }

  getRoamingCommunityInfo(id) {
    var body: any = {"virtId": id, "username": this.username};
    var url = ApiEndpoints.GET_ROAMING_COMMUNITY;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options =  {headers: headers};
    return this.http.post<any>(url, body, options);
  }

  getPlatforms(): Observable<any> {
    const url = ApiEndpoints.PLATFORMS;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    return this.http.post(url, {}, options);
  }

  getNetworkServerGroups(): Observable<any> {
    const url = ApiEndpoints.GET_ALL_NETWORK_SERVER_GROUPS;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    return this.http.post(url, {}, options);
  }
}
